import { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config/api";
import { authHeader } from "../../utils/authHeader";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import FraudDetailsModal from "./FraudDetailsModal";

import "swiper/css";
import "swiper/css/navigation";

const RecentFrauds = ({ canViewReportImages = true }) => {
  const [frauds, setFrauds] = useState([]);
  const [selectedFraud, setSelectedFraud] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const fetchFrauds = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/fraud/recent`, {
        headers: authHeader(),
      });
      setFrauds(res.data);
    } catch (error) {
      console.error("Failed to load recent frauds");
    }
  };

  useEffect(() => {
    fetchFrauds();
  }, []);

  return (
    <div className="recent-carousel">
      <h3 className="carousel-title">Recent Fraud Alerts</h3>

      <Swiper
        modules={[Navigation, Autoplay]}
        navigation
        loop={frauds.length > 1}
        autoplay={{ delay: 3000, disableOnInteraction: false }}

        // ✅ Responsive slides per view — no more overlapping
        breakpoints={{
          0:   { slidesPerView: 1, spaceBetween: 12 }, // mobile
          480: { slidesPerView: 2, spaceBetween: 14 }, // large mobile
          768: { slidesPerView: 3, spaceBetween: 16 }, // tablet
          1024:{ slidesPerView: 4, spaceBetween: 20 }, // desktop
        }}
      >
        {frauds.map((fraud) => (
          <SwiperSlide key={fraud._id}>
            <div
              className="fraud-slide"
              onClick={() => { if (canViewReportImages) { setSelectedFraud(fraud); setModalOpen(true); } }}
              style={{ cursor: canViewReportImages ? "pointer" : "default" }}
            >
              {fraud.proofImages?.[0] ? (
                <img src={fraud.proofImages[0]} alt="fraud proof" />
              ) : (
                <div style={{
                  width: "100%", height: "130px", background: "#f4f7fe",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: "32px",
                }}>
                  🚨
                </div>
              )}
              <div className="fraud-label">{fraud.fraudType}</div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <FraudDetailsModal
        open={modalOpen}
        fraud={selectedFraud}
        onClose={() => setModalOpen(false)}
      />
    </div>
  );
};

export default RecentFrauds;
